
<template>
	<contentBox mainId="auth" v-bind:loading="loading" v-bind:noMt="true">
		<contentTitle v-bind:label="getLabel()" labelClass="text-white" v-bind:close="routeBack" v-bind:noScroll="true">
		</contentTitle>
		<contentActions>
			<button class="btn btn-outline-light btn-sm" v-bind:class="{active:tabActive == 'login'}" 
				v-on:click="showTab('login')">
				Login
			</button>
			<button class="btn btn-outline-light btn-sm" v-bind:class="{active:tabActive == 'signUp'}" v-on:click="showTab('signUp')">
				Sign Up
			</button>
		</contentActions>
		<contentBody>
			<div v-if="tabActive == 'login'" class="p-3">
				<form class="" v-on:submit.prevent="login">
					<div class="form-group">
						<label class="mb-1" for="loginEmail">Email</label>
						<input type="email" class="form-control" id="loginEmail" aria-describedby="emailHelp" 
							placeholder="Enter email" v-model="email"
							v-bind:class="{'is-invalid':error && error.email}"/>
						<div class="invalid-feedback">
							{{error && error.email}}
				        </div>
					</div>
					<div class="form-group">
						<label class="mb-1" for="loginPassword">Password</label>
						<input type="password" class="form-control" id="loginPassword" 
							placeholder="Password" v-model="password"
							v-bind:class="{'is-invalid':error && error.password}"/>
						<div class="invalid-feedback">
							{{error && error.password}}
				        </div>
						<small id="passwordHelp" class="form-text text-muted">Forget your password? <a href="/users/forgot-password">Recover it</a></small>
					</div>
					<button class="btn btn-lg btn-dark btn-block" type="submit">Login</button>
				</form>
			</div>
			<div v-if="tabActive == 'signUp'" class="p-3">
				<form class="" v-on:submit.prevent="signUp">
					<div class="form-group">
						<label class="mb-1" for="signUpEmail">Email</label>
						<input type="email" class="form-control" id="signUpEmail" aria-describedby="emailHelp" 
							placeholder="Enter email" v-model="email"
							v-bind:class="{'is-invalid':error && error.email}"/>
						<div class="invalid-feedback">
							{{error && error.email}}
				        </div>
						<small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>
					</div>
					<div class="form-group">
						<label class="mb-1" for="signUpPassword">Password</label>
						<input type="password" class="form-control" id="signUpPassword" 
							placeholder="Password" v-model="password"
							v-bind:class="{'is-invalid':error && error.password}"/>
						<div class="invalid-feedback">
							{{error && error.password}}
				        </div>
						<small id="emailHelp" class="form-text text-muted">Minimum 4 characters.</small>
					</div>
					<button class="btn btn-lg btn-dark btn-block" type="submit">Sign Up</button>
				</form>
			</div>

		</contentBody>

	</contentBox>
</template>
<script>

import contentBox from '../content';
import contentActions from '../content/content-actions';
import contentBody from '../content/content-body';
import contentTitle from '../content/content-title';

let fromPath;

export default {
	name: 'auth',
	beforeRouteEnter:function(to, from, next){
		if (from && from.name !== 'auth' && from.name !== 'auth-tab' && from.name !== 'agent-tab') fromPath = from;
		next();
	},
	components:{
		contentBox,
		contentActions,
		contentBody,
		contentTitle
	},
	created:function(){
		if (this.$route.params.tab) this.tabActive = this.$route.params.tab;
	},

	data: function(){
		return {
			email: null,
			password: null,
			tabActive:'signUp',
			loading:false,
			error:null
		}
	},
   methods: {
   	getLabel:function(){
   		if (this.tabActive === 'signUp') return 'JOIN SCOUTRED';
   		return 'LOGIN TO SCOUTRED';
   	},
  	login: function(){
  		this.loading = true;
  		this.clearErrors();
  		if (this.email === null || this.email.length < 1){
				this.formError({email:'enter an email'});
			}
			if (this.password === null || this.password.length < 1){
				this.formError({password:'enter a password'});
			}
			if (this.error !== null) return;
			this.$store.dispatch('AGENT_LOGIN', {email: this.email, password: this.password}).then(()=>{
				if (fromPath) return this.$router.push(fromPath.fullPath);
				this.$router.push({name:'home'});
			}).catch((e)=>{
				this.formError({password:'error logging in'});
			});
  	},
  	signUp: function(){
			this.loading = true;
			this.clearErrors();
  		if (this.email === null || this.email.length < 1){
				this.formError({email:'enter an email'});
			}
			if (this.password === null || this.password.length < 1){
				this.formError({password:'enter a password'});
			}
			if (this.error !== null) return;
			this.$store.dispatch('AGENT_SIGNUP', {email: this.email, password: this.password}).then(()=>{
				if (fromPath) return this.$router.push(fromPath.fullPath);
				this.$router.push({name:'home'});
			}).catch((e)=>{
				this.formError({password:'error signing up'});
			});
  	},
  	clearErrors:function(err){
			this.error = null;
		},
    formError:function(err){
			this.loading = false;
			this.error = this.error || {};
			for (let i in err){
				this.error[i] = err[i];
			}
		},
		showTab:function(tab){
			this.$router.push({
				name:'auth-tab',
				params:{
					tab:tab
				}
			});
		},
		routeBack:function(){
			if (fromPath){
				return this.$router.push({...fromPath});
			}
			this.$router.push({
				name:'home'
			});
		}
	},
	watch:{
		$route:function(toRoute, fromRoute){
			this.clearErrors();
			if (toRoute.params.tab){
				this.tabActive = toRoute.params.tab;
			}
		}
	}
}

</script>

<style>
.mobile #auth{
	position:fixed !important;
	bottom:0;
	top:0;
	left:0;
	right:0;
	flex-direction: column!important;
	display: flex!important;
}
#auth .back-btn{
	margin-left:-7px;
	margin-top:-1px;
}
.nav-link{
	cursor:pointer;
	color:#CCC;
}
.nav-link:hover{
	color:#EEE;
}
.parcel-options i{
	cursor:pointer;
	color:#868e96;
}
.parcel-options i:hover{
	color:#FFFFFF;
}
.close-btn{
	color:#6F6F6F;
	cursor:pointer;
	margin-top:2px;
}
.close-btn:hover{
	color:#4E4E4E;
}
.text-title{
	color:#6F6F6F;
}
#login .border-bottom-gray{
	border-bottom:1px solid #EEE;
}
.mt-login{
	margin-top:54px;
}
</style>


// WEBPACK FOOTER //
// src/components/auth/index.vue